import { useDelete, useNavigation, useModal } from "@refinedev/core";

// It is recommended to use explicit import as seen below to reduce bundle size.
// import { IconName } from "@ant-design/icons";
import * as Icons from "@ant-design/icons";

import { Dropdown, Menu, Modal, Spin } from "antd";
import { IApiKey } from "interfaces";
import { useState } from "react";

const { FormOutlined, DeleteOutlined } = Icons;

type ApiKeyActionProps = {
  record: IApiKey;
};

export const ApiKeyActions: React.FC<ApiKeyActionProps> = ({ record }) => {
  const { mutate } = useDelete();

  const [isDeleting, setIsDeleting] = useState(false);

  const deleteOrder = (id: any) => {
    setIsDeleting(true);

    mutate({
      resource: "keys",
      id,
    }, {
      onSettled: () => setIsDeleting(false)
    });
  };

  const { visible: isDeleteModalVisible, show: showDeleteModal, close: closeDeleteModal } = useModal();

  const { edit, show } = useNavigation();
  const moreMenu = (record: IApiKey) => (
    <Menu
      mode="vertical"
      onClick={({ domEvent }) => domEvent.stopPropagation()}
    >
      <Menu.Item
        key="2"
        style={{
          fontWeight: 500,
        }}
        icon={
          <FormOutlined
            style={{
              color: "green",
            }}
          />
        }
        onClick={() => edit("keys", record.id)}
      >
        Edit API Key
      </Menu.Item>
      <Menu.Item
        key="3"
        style={{
          fontWeight: 500,
        }}
        icon={
          <DeleteOutlined
            style={{
              color: "red",
            }}
          />
        }
        onClick={showDeleteModal}
      >
        Delete API Key
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Modal
        title="Delete API Key"
        open={isDeleteModalVisible}
        onCancel={closeDeleteModal}
        okButtonProps={{
          style: { backgroundColor: "red", width: 70 }
        }}
        okText={
          isDeleting
            ? <Spin indicator={<Icons.LoadingOutlined spin style={{ color: "#fff" }} />} />
            : "Delete"
        }
        onOk={() => {
          deleteOrder(record.id);
        }}
      >
        Are you sure you want to delete API Key for <b>{record.service}</b>?
      </Modal>
      <Dropdown overlay={moreMenu(record)} trigger={["click"]}>
        <Icons.MoreOutlined
          onClick={(e) => e.stopPropagation()}
          style={{
            fontSize: 24,
          }}
        />
      </Dropdown>
    </>
  );
};
